import { Button, FormControl, InputAdornment, TextField, useMediaQuery } from '@mui/material';
import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import './authentication.css'
import { useFormik } from "formik";
import { useResetPasswordMutation } from '../../features/authApi';
import { useTheme } from '@emotion/react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { toast } from 'react-hot-toast';

const PasswordReset = () => {
  const [ResetPasswordError, setResetPasswordError] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  const [resetPassword] = useResetPasswordMutation()

  
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const handleShowPassword = () => setShowPassword(!showPassword);
  const handleShowPasswordConfirm = () => setShowPasswordConfirm(!showPasswordConfirm);

  const {userId, uniqueString} = useParams();

  const theme = useTheme()

  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));
  const isLg= useMediaQuery(theme.breakpoints.down('lg'));
  const isXl= useMediaQuery(theme.breakpoints.down('xl'));

  const onSubmit = async (values, actions) => {
    console.log("CALLED RESET PASSWORD")
    resetPassword(
      {_id: userId, uniqueString: uniqueString, password: values.password, confirmPassword: values.confirmPassword},
      {id: userId })
    .then(res => {
      navigate("/login")
      toast.success("Password resetted successfully")
      if(!res.error) {
      }
      else {
        console.log("values are", values)
        console.log("error", res)
        setErrorMessage(res.error.data.message)
        setResetPasswordError(true)
      }
    })
    .catch((e) => {
      console.log("wrong credentials", e)
    })
  };



  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
      userId,
      uniqueString,
    },
    onSubmit,
  });

  console.log(errors);

  const navigate = useNavigate()

  const renderMobileResetPassword = () => (
    <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
    <form onSubmit={handleSubmit} autoComplete="off" style={{width: '75%'}}>
      <h3 className="center">Password Reset</h3>
      <p className="center" style={{color:'red', fontWeight:'bold'}}>{}</p>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
            <TextField
              id="password"
              type={showPassword ? 'text' : 'password'}
              margin="dense"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              label="new password"
              className={errors.password && touched.password ? "input-error" : ""}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    {
                      <VisibilityIcon color="primary" className="iconClass" sx={{backgroundColor:'#fff !important'}} onClick={handleShowPassword}/>
                    }
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
          {errors.password && touched.password && (
            <p className="error">{errors.password}</p>
          )}
  

          <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
            <TextField
              id="confirmPassword"
              type={showPasswordConfirm ? 'text' : 'password'}
              margin="dense"
              value={values.confirmPassword}
              onChange={handleChange}
              onBlur={handleBlur}
              label="confirm new password"
              className={
                errors.confirmPassword && touched.confirmPassword ? "input-error" : ""
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    {
                      <VisibilityIcon color="primary" sx={{backgroundColor:'#fff !important'}} className="iconClass" onClick={handleShowPasswordConfirm}/>
                    }
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
          {errors.confirmPassword && touched.confirmPassword && (
            <p className="error">{errors.confirmPassword}</p>
          )}

      <div className="btnContainer">
        <Button variant="contained" color="primary" sx={{width: '125px'}} type="submit">
          Reset
        </Button>
      </div>
    </form>

  </div>
  )

  const renderTabletResetPassword = () => (
    <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
    <form onSubmit={handleSubmit} autoComplete="off" style={{width: '75%'}}>
      <h3 className="center">Password Reset</h3>
      <p className="center" style={{color:'red', fontWeight:'bold'}}>{}</p>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
            <TextField
              id="password"
              type={showPassword ? 'text' : 'password'}
              margin="dense"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              label="new password"
              className={errors.password && touched.password ? "input-error" : ""}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    {
                      <VisibilityIcon color="primary" className="iconClass" sx={{backgroundColor:'#fff !important'}} onClick={handleShowPassword}/>
                    }
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
          {errors.password && touched.password && (
            <p className="error">{errors.password}</p>
          )}
  

          <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
            <TextField
              id="confirmPassword"
              type={showPasswordConfirm ? 'text' : 'password'}
              margin="dense"
              value={values.confirmPassword}
              onChange={handleChange}
              onBlur={handleBlur}
              label="confirm new password"
              className={
                errors.confirmPassword && touched.confirmPassword ? "input-error" : ""
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    {
                      <VisibilityIcon color="primary" sx={{backgroundColor:'#fff !important'}} className="iconClass" onClick={handleShowPasswordConfirm}/>
                    }
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
          {errors.confirmPassword && touched.confirmPassword && (
            <p className="error">{errors.confirmPassword}</p>
          )}

      <div className="btnContainer">
        <Button variant="contained" color="primary" sx={{width: '125px'}} type="submit">
          Reset
        </Button>
      </div>
    </form>

  </div>
  )

  const renderDesktopResetPassword = () => (
    <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
    <form onSubmit={handleSubmit} autoComplete="off">
      <h3 className="center">Password Reset</h3>
      <p className="center" style={{color:'red', fontWeight:'bold'}}>{}</p>

      <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
            <TextField
              id="password"
              type={showPassword ? 'text' : 'password'}
              margin="dense"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              label="new password"
              className={errors.password && touched.password ? "input-error" : ""}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    {
                      <VisibilityIcon color="primary" className="iconClass" sx={{backgroundColor:'#fff !important'}} onClick={handleShowPassword}/>
                    }
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
          {errors.password && touched.password && (
            <p className="error">{errors.password}</p>
          )}
  

          <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
            <TextField
              id="confirmPassword"
              type={showPasswordConfirm ? 'text' : 'password'}
              margin="dense"
              value={values.confirmPassword}
              onChange={handleChange}
              onBlur={handleBlur}
              label="confirm new password"
              className={
                errors.confirmPassword && touched.confirmPassword ? "input-error" : ""
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    {
                      <VisibilityIcon color="primary" sx={{backgroundColor:'#fff !important'}} className="iconClass" onClick={handleShowPasswordConfirm}/>
                    }
                  </InputAdornment>
                ),
              }}
            />
          </FormControl>
          {errors.confirmPassword && touched.confirmPassword && (
            <p className="error">{errors.confirmPassword}</p>
          )}

      <div className="btnContainer">
        <Button variant="contained" color="primary" sx={{width: '125px'}} type="submit">
          Reset
        </Button>
      </div>
    </form>

  </div>
  )
  

  return (
    <div>
        {
        (isXs) ?  renderMobileResetPassword() : 
        (isSm) ? renderMobileResetPassword() :
        (isMd) ? renderTabletResetPassword() :
        renderDesktopResetPassword()
      }
    </div>
  );
}

export default PasswordReset